import React, { useState } from 'react';
import type { ISODateRange } from 'shared/src/date-string-utils/types';
import { ExpiredDailyKpis } from './expired-daily-kpis';
import { Last7DaysDeliveryKpis } from './last-7-days-delivery-kpis';
import { Last7DaysSpendKpis } from './last-7-days-spend-kpis';
import { PacingDeliveryKpis } from './pacing-delivery-kpis';
import { PacingSpendKpis } from './pacing-spend-kpis';
import { getDateRangeState } from './metric-date-utils';
import type { TimeFrameMode } from './time-frame-utils';

export type KpiViewMode = 'delivery' | 'spend';

type Props = {
  timeFrameMode: TimeFrameMode;
  dateRange: ISODateRange;
};

export function LineItemDailyKpis({ timeFrameMode, dateRange }: Props) {
  const [viewMode, setViewMode] = useState<KpiViewMode>('delivery');

  if (timeFrameMode !== 'last_7_days') {
    const state = getDateRangeState(dateRange);
    if (state === 'expired') {
      return <ExpiredDailyKpis dateRange={dateRange} timeFrameMode={timeFrameMode} />;
    }
  }

  if (viewMode === 'spend') {
    if (timeFrameMode === 'last_7_days') {
      return <Last7DaysSpendKpis setViewMode={setViewMode} />;
    }
    return <PacingSpendKpis setViewMode={setViewMode} />;
  }

  if (timeFrameMode === 'last_7_days') {
    return <Last7DaysDeliveryKpis setViewMode={setViewMode} />;
  }
  return <PacingDeliveryKpis timeFrameMode={timeFrameMode} setViewMode={setViewMode} />;
}
